<template>
  <div v-cloak>
    <div class="alert alert-ss-primary fade show" role="alert">
      <div class="alert-icon">
        <i class="flaticon-warning" />
      </div>
      <div class="alert-text">
        Streams assigned or updated here will not be automatically assigned or updated in 3rd party EPG. You must inform
        the development team to make manual changes as well. To confirm changes have taken effect please check scheduler
        page.
      </div>
      <div class="alert-close">
        <button type="button" class="close"
                data-dismiss="alert"
                aria-label="Close">
          <span aria-hidden="true"><i class="la la-close" /></span>
        </button>
      </div>
    </div>

    <div class="alert alert-ss-primary fade show" role="alert">
      <div class="alert-icon">
        <i class="flaticon-warning" />
      </div>
      <div class="alert-text">
        Streams assigned or updated on this page are currently not compatible with Rewind. Please setup recording configurations directly: <a target="_blank" :href="rewind_url">{{ rewind_url }}</a>
      </div>
      <div class="alert-close">
        <button type="button" class="close"
                data-dismiss="alert"
                aria-label="Close">
          <span aria-hidden="true"><i class="la la-close" /></span>
        </button>
      </div>
    </div>

    <div class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            Stream Management
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-4">
            <button class="btn btn-ss w-100" @click.prevent="$modal.show(`add-stream-modal`)">
              <span>
                <i class="fa fa-plus" />
                <span>New Stream</span>
              </span>
            </button>
          </div>

          <div class="col-4">
            <button class="btn btn-ss w-100" @click.prevent="$modal.show(`update-stream-modal`)">
              <span>
                <i class="fa fa-pen" />
                <span>Update Stream</span>
              </span>
            </button>
          </div>

          <div class="col-4">
            <button id="delete-stream-button" class="btn btn-ss-danger w-100"
                    @click.prevent="$modal.show(`delete-stream-modal`)">
              <span>
                <i class="fa fa-trash" />
                <span>Delete Stream</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            Stream Assignment
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <customer-dropdown v-model="customer" :customers="customers" />
        <customer-stream-details v-model="customer_streams" :customer="customer" :global-streams="global_streams" />
        <div v-if="customer.uuid" class="col-12">
          <br>
          <button
            class="btn btn-ss-standout" @click="() => updateStreams(customer, customer_streams)">
            <span>
              <i class="la la-save" />
              <span>Save Streams</span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <add-stream-modal @input="storeStream" />
    <update-stream-modal :streams="global_streams" @input="({ old_name, ...stream }) => patchStream(old_name, stream)" />
    <delete-stream-modal @input="destroyStream" />
  </div>
</template>

<script>
import CustomerDropdown from "VueComponents/CustomerDropdown";
import CustomerStreamDetails from "VuePartials/Admin/CustomerStreamDetails";
import AddStreamModal from "VuePartials/Admin/VJSModals/AddStreamModal";
import UpdateStreamModal from "VuePartials/Admin/VJSModals/UpdateStreamModal.vue";
import DeleteStreamModal from "VuePartials/Admin/VJSModals/DeleteStreamModal";

import { mapActions, mapWritableState } from "pinia";
import useAdminStore from "VueStore/admin/general";
import useStreamsStore from "VueStore/admin/streams";

export default {
  components: {
    CustomerDropdown,
    CustomerStreamDetails,
    AddStreamModal,
    DeleteStreamModal,
    UpdateStreamModal,
  },
  data: () => ({
    rewind_url: window.rewind_url,
  }),
  computed: {
    ...mapWritableState(useAdminStore, [
      'customer',
      'customers',
    ]),
    ...mapWritableState(useStreamsStore, [
      'global_streams',
      'customer_streams',
    ]),
  },
  watch: {
    customer: {
      deep: true,
      handler: async function (new_val) {
        this.fetchCustomerStreams(new_val);
      },
    },
  },
  async beforeMount() {
    this.fetchCustomers();
    this.fetchAll();
  },
  methods: {
    ...mapActions(useAdminStore, [
      'fetchCustomers',
    ]),
    ...mapActions(useStreamsStore, [
      'fetchAll',
      'fetchCustomerStreams',
      'updateStreams',
      'patchStream',
      'storeStream',
      'destroyStream',
    ]),
  },
};
</script>
